import Divider from '@mui/material/Divider'
import { SxProps, Theme } from '@mui/material/styles'
import tw, { styled } from 'twin.macro'

export const menuPaperSx: SxProps<Theme> = {
  maxWidth: 'calc(100vw - 50px) !important',
  width: 385,
  marginTop: '0.5rem',
  display: 'flex',
  flexWrap: 'wrap',
  overflow: 'hidden',
  '& > .MuiMenu-list': { width: '100%' },
  '& p': { mt: 0 },
  '& button': { fontFamily: 'Nunito, Helvetica Neue, sans-serif' },
}

export const StyledDivider = styled(Divider)(() => [tw`bg-monochrome-900/[.15]`])

export interface StyledMenuSectionProps {
  borderTop?: boolean
  borderBottom?: boolean
}
export const StyledMenuSection = styled.div<StyledMenuSectionProps>(
  ({ borderTop, borderBottom }) => [
    borderTop ? tw`border-monochrome-900/[.15] border-t` : '',
    borderBottom ? tw`border-monochrome-900/[.15] border-b` : '',
  ],
)

export const StyledMenuSectionContent = styled(StyledMenuSection)(() => [tw`px-2 py-4`])

export const StyledMenuTitle = styled.div(() => [
  tw`px-4 font-sans font-normal text-monochrome-900/[0.65] text-xs uppercase leading-8 tracking-wider`,
])
